<template>
  <div>
    <div class="so-title" style="text-align: center; width: auto; max-width: 100%">
      <div class="epiroc-container"></div>
    </div>

    <v-row align="center" class="mt-12" v-if="loggedIn">
      <v-btn
        type="button"
        color="#fdc300"
        large
        router
        to="/dashboard"
        class="login-btn"
      >{{ $t("common.dashboard") }}</v-btn>
    </v-row>

    <v-row align="center" class="mt-12" v-if="!loggedIn">
      <v-btn
        type="button"
        color="#fdc300"
        large
        router
        to="/login"
        class="login-btn"
      >{{ $t("common.login") }}</v-btn>
    </v-row>
    <!--
    <v-row align="center" class="mt-6" v-if="!loggedIn">
      <span
        style="text-align: center; color: white; margin: 0 auto; font-size: 1.2rem;"
      >{{ $t('landing.or') }}</span>
    </v-row>

    <v-row align="center" class="mt-6" v-if="!loggedIn">
      <v-btn
        type="button"
        color="#fdc300"
        large
        router
        to="/register"
        class="login-btn"
      >{{ $t("common.register") }}</v-btn>
    </v-row>
    -->
  </div>
</template>

<script>
export default {
  name: "LoginConetent",
  props: {
    loggedIn: {
      default: false,
      type: Boolean
    }
  }
};
</script>

<style scoped>
.epiroc-container {
  background-image: url("/epiroc-logo.png");
  background-position: center;
  background-size: contain;
  width: 100%;
  height: 100%;
  min-height: 200px;
}

.so-title {
  font-size: 3rem;
}

.slogan {
  text-align: left;
  width: 100%;
}

.lightgrey {
  color: rgb(192, 191, 191);
}

.login-btn {
  margin-top: 2rem;
  margin: 0 auto;
  width: 300px !important;
  color: white;
  font-size: 1rem;
}

.button-breathing {
  -webkit-animation: colorBreath 5s ease-out infinite normal;
  animation: colorBreath 5s ease-out infinite normal;
}

@media only screen and (max-width: 800px) {
  .so-title {
    font-size: 2rem;
  }
}
</style>